import React, { useState, useEffect } from "react";

const VoiceToText = () => {
  const [text, setText] = useState("");
  const [isListening, setIsListening] = useState(false);

  useEffect(() => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Your browser does not support Speech Recognition. Try Chrome.");
    }
  }, []);

  let recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();

  recognition.continuous = true; // Keeps listening until stopped
  recognition.interimResults = true; // Shows real-time results
  recognition.lang = "en-US"; // English language

  recognition.onresult = (event) => {
    let transcript = "";
    for (let i = event.resultIndex; i < event.results.length; i++) {
      transcript += event.results[i][0].transcript;
    }
    setText(transcript);
  };

  recognition.onerror = (event) => {
    console.error("Speech Recognition Error:", event.error);
  };

  const startListening = () => {
    setIsListening(true);
    recognition.start();
  };

  const stopListening = () => {
    setIsListening(false);
    recognition.stop();
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>Voice to Text</h2>
      <button onClick={startListening} disabled={isListening} style={{ margin: "10px", padding: "10px" }}>
        🎤 Start Listening
      </button>
      <button onClick={stopListening} disabled={!isListening} style={{ margin: "10px", padding: "10px" }}>
        🛑 Stop Listening
      </button>
      <div style={{ marginTop: "20px", border: "1px solid #ddd", padding: "10px", minHeight: "50px" }}>
        <strong>Extracted Text:</strong>
        <p>{text || "Start speaking..."}</p>
      </div>
    </div>
  );
};

export default VoiceToText;
